(function () {
  const gridEl = document.querySelector('[data-grid]')
  const foot = document.querySelector('[data-grid-foot]')
  if (!gridEl || !foot) {
    return
  }

  const AVAILABILITY = 'filter.v.availability'
  const url = new URL(window.location.href)

  /*
     With the availability filter on, Shopify paginates counting only what can be
     bought: each page brings its 28 and the numbers match what is on screen. Without it
     the page arrives short, because it counts the sold-out items too, which are not
     rendered here. When that happens the same page is requested already filtered: what
     the server rendered is the start of that list, so it is enough to append what is
     missing. Nothing reloads and nothing the shopper is already looking at moves.
  */
  if (url.searchParams.has(AVAILABILITY)) {
    return
  }

  url.searchParams.set(AVAILABILITY, '1')
  const request = new URL(url.toString())
  request.searchParams.set('view', 'cards')

  fetch(request.toString(), { credentials: 'same-origin' })
    .then(function (response) {
      return response.ok ? response.text() : null
    })
    .then(function (html) {
      if (!html) {
        return
      }
      const box = document.createElement('div')
      box.innerHTML = html

      const fullCards = box.querySelectorAll('[data-cards] .pjs-card-wrap')
      for (let i = gridEl.children.length; i < fullCards.length; i++) {
        gridEl.appendChild(fullCards[i])
      }

      /*
         The server's numbers counted pages of 28 with sold-out items inside, so
         they were wrong: they are replaced by the filtered list's. Their links come
         from the URL that was requested, which has to have the data view stripped
         out.
      */
      const nextPagination = box.querySelector('[data-pagination]')
      if (nextPagination) {
        Array.prototype.forEach.call(nextPagination.querySelectorAll('a[href]'), function (a) {
          const target = new URL(a.getAttribute('href'), window.location.origin)
          target.searchParams.delete('view')
          a.setAttribute('href', target.pathname + target.search)
        })
        foot.innerHTML = nextPagination.innerHTML
      }

      /*
         The address takes the filter without reloading, so sharing it or reloading
         returns exactly this page.
      */
      window.history.replaceState(null, '', url.pathname + url.search)

      /*
         A whole page of sold-out items is not an empty collection, so Shopify gives
         no message and the grid was left blank with no explanation.
      */
      const notice = document.querySelector('[data-grid-empty]')
      if (notice && gridEl.children.length === 0) {
        notice.hidden = false
        gridEl.hidden = true
      }
    })
    .catch(function () {
      /* if it fails, what the server rendered stays */
    })
})()
